import { PieChart } from "recharts";

const BasePieChart = (props)=>{
    return <PieChart {...props}>
        {props.children}
    </PieChart>
}

export default BasePieChart;